import React from "react";

const slugColor = (color) => color.toLowerCase().replace(/\s+/g, "-");
const colorMap = {
  black: "#050505",
  white: "#ffffff",
  "navy blue": "#0b1f44",
  navy: "#0b1f44",
  beige: "#d7c2a2",
  charcoal: "#2f3033",
  red: "#ef3333",
  grey: "#7a7a7a",
  gray: "#7a7a7a",
  blue: "#2454d6",
  green: "#166534",
  yellow: "#facc15",
  pink: "#f472b6",
  purple: "#7c3aed",
  brown: "#7c4a2d",
};

const swatchFor = (color) => colorMap[String(color || "").trim().toLowerCase()] || "#3f3f46";

const ColorSelector = ({ colors = [], value, onChange, allLabel, testPrefix = "color" }) => (
  <div className="flex gap-2 flex-wrap">
    {allLabel && (
      <button
        type="button"
        onClick={() => onChange("")}
        aria-pressed={value === ""}
        className={`min-h-[44px] rounded-[8px] border px-4 py-2 font-mono text-xs transition ${value === "" ? "border-white bg-white text-black" : "border-white/20 hover:border-white"}`}
        data-testid={`${testPrefix}-all`}
      >
        {allLabel}
      </button>
    )}
    {colors.map((color) => (
      <button
        type="button"
        key={color}
        onClick={() => onChange(color)}
        aria-pressed={value === color}
        className={`inline-flex min-h-[48px] min-w-[104px] items-center gap-2 rounded-[8px] border px-3 py-3 font-mono text-xs uppercase tracking-[0.14em] transition ${
          value === color ? "border-cynos-red bg-cynos-red/15 text-white ring-1 ring-cynos-red" : "border-white/20 text-zinc-200 hover:border-white"
        }`}
        data-testid={`${testPrefix}-${slugColor(color)}`}
      >
        <span
          className={`h-4 w-4 shrink-0 rounded-full border ${String(color).toLowerCase() === "white" ? "border-zinc-400" : "border-white/25"}`}
          style={{ backgroundColor: swatchFor(color) }}
          aria-hidden="true"
        />
        <span>{color}</span>
      </button>
    ))}
  </div>
);

export default ColorSelector;
